/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Pure_Hen_PokeInputs */

const en_quiet_pure_hen_poke = /** @type {(inputs: Quiet_Pure_Hen_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login disabled`)
};

const de_quiet_pure_hen_poke = /** @type {(inputs: Quiet_Pure_Hen_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login nicht aktiviert`)
};

/**
* | output |
* | --- |
* | "Login disabled" |
*
* @param {Quiet_Pure_Hen_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_pure_hen_poke = /** @type {((inputs?: Quiet_Pure_Hen_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Pure_Hen_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_pure_hen_poke(inputs)
	return de_quiet_pure_hen_poke(inputs)
});